<div>

  <div class="flex flex-row justify-start items-center flex-1-0-auto flex-1-0-auto">


    <div class="page-title">
      <h1>Transactions</h1>
    </div>

  </div>

  <div class="flex flex-row justify-start items-center flex-0-1-auto " >

    <div class="toolbar-separator"></div>
    <button mat-button [matMenuTriggerFor]="actionMenu"
            class="no-animation-btn">
      <div class="flex flex-row justify-center items-center">
        <span class="username mr-12">Actions</span>
        <mat-icon class="s-16">keyboard_arrow_down</mat-icon>
      </div>
    </button>
    <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
      <button *ngIf="(hasFeature$ | async)(transactionFeatures.CRTransactionImport)" mat-menu-item class=""
              (click)="navigateToTransactionsImport()">
        <span>Import Transactions</span>
      </button>
    </mat-menu>
  </div>


</div>
